"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Select = require("../form/Select");

var _Select2 = _interopRequireDefault(_Select);

var _UserUtil = require("../../utils/UserUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserVoucherPrint = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(UserVoucherPrint, _Component);

  function UserVoucherPrint() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserVoucherPrint);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserVoucherPrint.__proto__ || (0, _getPrototypeOf2.default)(UserVoucherPrint)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      quantity: 1
    }, _this.decreaseQuantity = function () {
      var _this$props = _this.props,
          vouchersAvailable = _this$props.vouchersAvailable,
          setNumbersForPrint = _this$props.setNumbersForPrint;


      if (_this.state.quantity > 1) {
        _this.setState({ quantity: --_this.state.quantity });
        setNumbersForPrint(_this.state.quantity);
      }
    }, _this.increaseQuantity = function () {
      var _this$props2 = _this.props,
          vouchersAvailable = _this$props2.vouchersAvailable,
          setNumbersForPrint = _this$props2.setNumbersForPrint;


      if (_this.state.quantity < vouchersAvailable) {
        _this.setState({ quantity: ++_this.state.quantity });
        setNumbersForPrint(_this.state.quantity);
      }
    }, _this.handlePrint = function (event) {
      event.preventDefault();
      var quantity = _this.state.quantity;

      _this.setState({ quantity: 1 });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UserVoucherPrint, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var vouchersAvailable = this.props.vouchersAvailable;

      this.setState({ quantity: vouchersAvailable });
    }
  }, {
    key: "render",
    value: function render() {
      var voucher = this.props.voucher;

      var vouchersAvailable = voucher.quantity - (voucher.quantity_printed || 0);

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "voucher-info" },
          "LIPUKKEITA OSTETTU: ",
          voucher.quantity,
          " TULOSTETTU: ",
          voucher.quantity_printed || 0
        ),
        vouchersAvailable > 0 ? _react2.default.createElement(
          "div",
          { className: "voucher-quantity" },
          _react2.default.createElement(
            "div",
            { className: "voucher-quantity-selector" },
            _react2.default.createElement(
              "div",
              { className: "voucher-quantity-button decrease-js", onClick: this.decreaseQuantity },
              "-"
            ),
            _react2.default.createElement(
              "div",
              { className: "voucher-quantity-text" },
              this.state.quantity
            ),
            _react2.default.createElement(
              "div",
              { className: "voucher-quantity-button increase-js", onClick: this.increaseQuantity },
              "+"
            )
          )
        ) : "",
        _react2.default.createElement("div", { className: "clear" })
      );
    }
  }, {
    key: "renderVoucherAddress",
    value: function renderVoucherAddress(place) {
      return place && (0, _UserUtil.formatAddress)(place.address, place.postal_code, place.city);
    }
  }]);
  return UserVoucherPrint;
}(_react.Component), _class.propTypes = {
  voucher: _react.PropTypes.object.isRequired,
  vouchersAvailable: _react.PropTypes.number.isRequired,
  setNumbersForPrint: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = UserVoucherPrint;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/uservouchers/UserVoucherPrint.js
 ** module id = 1195
 ** module chunks = 0
 **/